var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"headerPanel"},[_c('HeaderPanel')],1),_c('div',{staticClass:"navbarPanel"},[_c('NavbarPanel')],1),_c('div',{staticClass:"mainDocuments"},[_c('LoginConfigs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }